import { createContext } from 'react';
import { sentry } from '@frontend/tracking';

type StepContextType = {
  isEditMode?: boolean;
  isChangingStep?: boolean;
  omitBackActions?: boolean;
  onCancelClick: () => void;
  onBackClick: () => void;
  onClose: () => void;
};

export const StepContext = createContext<StepContextType>({
  isEditMode: false,
  isChangingStep: false,
  omitBackActions: false,
  onCancelClick: () => {
    console.warn('onCancelClick not provided');
    sentry.warn({
      team: 'fe-phone-config',
      error: 'onCancelClick not provided',
      topic: 'phone-config',
    });
  },
  onBackClick: () => {
    console.warn('onBackClick not provided');
    sentry.warn({
      team: 'fe-phone-config',
      error: 'onBackClick not provided',
      topic: 'phone-config',
    });
  },
  onClose: () => {
    console.warn('onClose not provided');
    sentry.warn({
      team: 'fe-phone-config',
      error: 'onClose not provided',
      topic: 'phone-config',
    });
  },
});
